import React, { useEffect, useState } from 'react'
import './datatable.css'
import { Clear } from '@material-ui/icons';

const DataTable = ({ array, coverIndex, removeRow }) => {

  const [data, setData] = useState()
  const [totalExhaustAir, setTotalExhaustAir] = useState()
  const [supplyAir, setSupplyAir] = useState(0.8)


  useEffect(() => {
    setData(array)
  }, [array])

  useEffect(() => {
    data !== undefined && calculateTotalExhaustAir(data)
  })

  const calculateTotalExhaustAir = (data) => {
    let totalExhaust = data.map(obj => obj.exhaustAir).reduce((prev, curr) => prev + curr, 0)
    setTotalExhaustAir(totalExhaust)

  }
  const handleSupplyAirChange = (e) => {
    setSupplyAir(e.target.value)
  }

  return (
    <>
      <div className='dataTableDiv'>
        {array.length > 0 &&
          <><span className='table-title'><p>{`Kåpa ${coverIndex}`}</p></span>
            <table key={coverIndex} cellSpacing="0">
              <tbody>
                <tr>
                  <th>Köksmaskin</th>
                  <th>Effekt, kW</th>
                  <th>Antal</th>
                  <th>Frånluft, l/s</th>
                  <th className='delete-icon'></th>
                </tr>
                {data !== undefined && data.map((obj, rowIndex) => {
                  return <tr key={rowIndex}>
                    <td>{obj.machine}</td>
                    <td>{obj.effect}</td>
                    <td>{obj.quantity}</td>
                    <td>{Math.round(obj.exhaustAir)}</td>
                    <td className='delete-icon' onClick={() => removeRow(coverIndex, rowIndex)}><Clear color='error' /></td>
                  </tr>

                })}
              </tbody>
            </table>
            <div className='total-airflow-container' >
              <div className='total-airflow-container-child'>
                <label>Tilluft</label>
                <select value={supplyAir} onChange={handleSupplyAirChange}>
                  <option value={0.7}>70%</option>
                  <option value={0.8}>80%</option>
                  <option value={0.9}>90%</option>
                </select>
              </div>
              <div className='total-airflow-container-child'>
                <label >Tilluft</label>
                <input disabled placeholder={Math.round(totalExhaustAir * supplyAir) || ''}></input>
              </div>
              <div className='total-airflow-container-child'>
                <label >Frånluft totalt</label>
                <input disabled placeholder={Math.round(totalExhaustAir)}></input>
              </div>
            </div>
          </>
        }

      </div>
    </>
  )
}

export default DataTable
